class IntroOverlay {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        let storage = sessionStorage.getItem("intro");

        if (storage == null) {
            sessionStorage.setItem("intro", "true");
            self.elem.classList.add('has-animation');

            document.addEventListener("DOMContentLoaded", (event) => {
                setTimeout(function() {
                    self.elem.classList.add('is-not-active');
                }, 4000);
            });
        } else {
            self.elem.classList.add('is-not-active');
        };
    }
}

export default IntroOverlay;
